import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box, useDocumentTitle } from "@entur-partner/common";
import { BannerAlertBox } from "@entur/alert";
import { Button } from "@entur/button";

interface ErrorMessageProps {
  retry?: () => void;
  descriptionKey?: string;
  className?: string;
}

export const ErrorMessage: FC<ErrorMessageProps> = ({
  retry,
  descriptionKey = "error-message.description",
  ...rest
}) => {
  const { t } = useTranslation();
  useDocumentTitle({ title: t("error-message.title") });

  return (
    <BannerAlertBox variant="error" title={t("error-message.title")} {...rest}>
      {t(descriptionKey)}
      {retry && (
        <Box marginTop="extraSmall">
          <Button onClick={retry} variant="primary">
            {t("error-message.retry")}
          </Button>
        </Box>
      )}
    </BannerAlertBox>
  );
};
